import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
  PointOfSale as PointOfSaleIcon,
  LocalShipping as LocalShippingIcon,
  AddBox as AddBoxIcon,
  Inventory as InventoryIcon,
  CreditCard as CreditCardIcon,
  Assessment as AssessmentIcon,
  ShowChart as ShowChartIcon,
} from '@mui/icons-material';
import { DASHBOARD_QUICK_ACTIONS } from './dashboardQuickActions';
import { DASHBOARD_COLORS, sectionPaperSx, sectionTitleSx } from './dashboardStyles';

const ICON_MAP = {
  F1: { icon: PointOfSaleIcon, iconColor: '#FF5722' },
  F2: { icon: LocalShippingIcon, iconColor: '#7c3aed' },
  F3: { icon: AddBoxIcon, iconColor: '#2563eb' },
  F4: { icon: InventoryIcon, iconColor: '#2563eb' },
  F5: { icon: CreditCardIcon, iconColor: '#6366f1' },
  F6: { icon: AssessmentIcon, iconColor: '#0d9488' },
  F7: { icon: ShowChartIcon, iconColor: '#059669' },
  F8: { icon: PointOfSaleIcon, iconColor: '#FF5722' },
};

const QuickActions = ({ onNavigate, actions }) => {
  const items = actions?.length ? actions : DASHBOARD_QUICK_ACTIONS;
  if (!items.length) return null;

  return (
  <Paper elevation={0} sx={sectionPaperSx}>
    <Typography sx={sectionTitleSx}>Quick Actions</Typography>
    <Box
      sx={{
        display: 'flex',
        gap: 1.25,
        flexWrap: { xs: 'wrap', lg: 'nowrap' },
        justifyContent: { xs: 'flex-start', lg: 'space-between' },
      }}
    >
      {items.map((action) => {
        const { icon: Icon, iconColor } = ICON_MAP[action.key] || ICON_MAP.F1;
        return (
          <Box
            key={`${action.id || action.label}-${action.key}`}
            component="button"
            type="button"
            onClick={() => onNavigate(action.path)}
            sx={{
              flex: { xs: '1 1 calc(25% - 12px)', sm: '1 1 calc(20% - 12px)', lg: '1 1 0' },
              minWidth: { xs: 100, sm: 110 },
              maxWidth: { lg: 'none' },
              border: `1px solid ${DASHBOARD_COLORS.border}`,
              borderRadius: 2,
              bgcolor: '#f0f4f8',
              py: 1.5,
              px: 1,
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: '#e2e8f0',
                borderColor: '#cbd5e1',
                transform: 'translateY(-1px)',
              },
            }}
          >
            <Icon sx={{ fontSize: 26, color: iconColor }} />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: DASHBOARD_COLORS.text,
                textAlign: 'center',
                lineHeight: 1.25,
                fontSize: '0.75rem',
              }}
            >
              {action.label}
            </Typography>
            <Typography variant="caption" sx={{ color: DASHBOARD_COLORS.textMuted, fontSize: '0.7rem' }}>
              ({action.shortcut})
            </Typography>
          </Box>
        );
      })}
    </Box>
  </Paper>
  );
};

export default QuickActions;
